import React, { Component } from "react";
import axios from "axios";
import { END_POINT } from "./endPoint";

export const UserContext = React.createContext();

export default class UserProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userDetail: JSON.parse(localStorage.getItem("userDetail")) || [],
      customerList: JSON.parse(localStorage.getItem("customerList")) || [],
      clpUserList: JSON.parse(localStorage.getItem("clpUserList")) || [],
      teamList: JSON.parse(localStorage.getItem("teamList")) || [],
      deviceList: JSON.parse(localStorage.getItem("deviceList")) || [],
    };
  }

  // ! ---------------------------- Customer ---------------------------- ! //
  getCustomers = async (data) => {
    await axios
      .post(`${END_POINT}/get/users`, data)
      .then((res) => {
        console.log("customerList", res.data);
        if (res.status === 200) {
          localStorage.setItem("customerList", JSON.stringify(res.data.users));
          this.setState({ customerList: res.data.users });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  downloadUsers = async () => {
    await axios({
      url: `${END_POINT}/download/users`,
      method: "GET",
      responseType: "blob", // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      console.log(response);
      const link = document.createElement("a");
      link.href = url;
      link.download = `CUSTOMERS.xlsx`;
      //   link.setAttribute("download", "data.xlsx"); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
  };

  downloadPDF = async () => {
    await axios({
      url: `${END_POINT}/download/pdf`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `CUSTOMERS.pdf`;
      document.body.appendChild(link);
      link.click();
    });
  };

  userRegister = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/register`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
  };

  userClpRegister = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/add/clp_user`, data)
      .then((res) => {
        //console.log("ClpRegister", res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
  };

  userClpUpdate = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/update/officer_profile`, data)
      .then((res) => {
        console.log("ClpUpdate", res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
    // await this.getCLPUser({ team_id: -1, role: "" });
  };

  userNewDevice = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/add/new/device`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
  };

  updateUser = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/update/user/detail`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
  };

  resetUserPassword = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/reset/user/password`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  deleteUser = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/delete/user`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  deleteUsers = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/delete/users`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  deleteDevice = async (data) => {
    let result = null;
    await axios
      .post(`${END_POINT}/delete/device`, data)
      .then((res) => {
        console.log(res.data);
        if (res.status === 200) {
          result = res.data;
        }
      })
      .catch((error) => {
        console.log(error);
      });
    return result;
  };

  // ! ---------------------------- Users ---------------------------- ! //
  loginClp = async (data) => {
    let result = {};
    await axios
      .post(`${END_POINT}/login/clp`, data)
      .then((res) => {
        if (res.data?.status?.result === "success") {
          console.log(res.data);
          localStorage.setItem("userDetail", JSON.stringify(res.data.data));
          this.setState({ userDetail: res.data.data });
        }
        result = res.data;
      })
      .catch((error) => {
        console.log(error);
      });

    return result;
  };

  logoutClp = () => {
    localStorage.clear();
  };

  getClpUser = async (data) => {
    await axios
      .post(`${END_POINT}/get/clp_user`, data)
      .then((res) => {
        // console.log(res.data);
        if (res.status === 200) {
          localStorage.setItem("clpUserList", JSON.stringify(res.data.users));
          this.setState({ clpUserList: res.data.users });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getTeams = async (data) => {
    await axios
      .post(`${END_POINT}/get/teams`, data)
      .then((res) => {
        // console.log(res.data);
        localStorage.setItem("teamList", JSON.stringify(res.data));
        this.setState({ teamList: res.data });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getClpMember = async () => {
    try {
      const response = await axios.post(`${END_POINT}/get/clp_member_line`);
      // console.log("ClpMemberList", response.data.memberList);
      if (response.status === 200) {
        localStorage.setItem("ClpMemberList", JSON.stringify(response.data.memberList));
        return response.data.memberList;
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  getDevice = async (data) => {
    try {
      const response = await axios.post(`${END_POINT}/get/mapping_device_model`,data);
      console.log("datacontextList", response.data);
      if (response.data.status.result === "success") {
        localStorage.setItem("datacontext", JSON.stringify(response.data));
        this.setState({ deviceList: response.data.deviceList });
        return response.data.deviceList;
      }
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const data = {
      userDetail: this.state.userDetail,
      customerList: this.state.customerList,

      clpUserList: this.state.clpUserList,
      teamList: this.state.teamList,

      deviceList: this.deviceList,
      // !------------ CUSTOMERS ------------
      getCustomers: this.getCustomers,
      downloadUsers: this.downloadUsers,
      userRegister: this.userRegister,
      updateUser: this.updateUser,
      resetUserPassword: this.resetUserPassword,
      deleteUser: this.deleteUser,
      deleteUsers: this.deleteUsers,
      userNewDevice: this.userNewDevice,
      deleteDevice: this.deleteDevice,
      // !------------ USERS ------------
      loginClp: this.loginClp,
      logoutClp: this.logoutClp,
      userClpRegister: this.userClpRegister,
      userClpUpdate: this.userClpUpdate,
      getClpUser: this.getClpUser,
      getTeams: this.getTeams,
      //userNew: this.userNew,
      getDevice: this.getDevice,
      getClpMember: this.getClpMember,
    };

    return (
      <UserContext.Provider value={data}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}

// UserProvider.contextType = DeviceContext;
